import React from 'react';
import cn from 'classnames';
import { Link } from '@/Framework/Router/Next/Link';
import Panel from '../../Panel';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import URL from '@/finsight/Router/urlConstants';

import aboutUsStyles from '../aboutUs.scss';

const contactUsSubtitles = [
  `We are driven to solve meaningful problems in the institutional capital markets space and have a great track
  record of doing so. If your company has unique challenges you wish us to explore, please get in touch.`
];

const ContactUs = () => (
  <Panel
    classNameWrapper={ cn(aboutUsStyles.topSpace, aboutUsStyles.bottomSpace) }
    title="How can we help?"
    subTitles={ contactUsSubtitles }
  >
    <div className={ aboutUsStyles.contentHolder }>
      <Link
        dataTest="contactUs"
        to={ URL.CONTACT }
      >
        <Button
          variant={ ButtonVariantType.action }
          title="Contact Us"
          dataTest="contactUsButton"
        />
      </Link>
    </div>
  </Panel>
);

export default ContactUs;
